<template>
  <div class="block page24">
    <div class="bg">
      <img :src="moduleData?.background_img || DEFAULT_COVER" alt="">
      <img v-if="!!bottomLogo" :src="bottomLogo" alt="">
    </div>
<!--    <PageTips />-->
  </div>
</template>

<script setup>
import DEFAULT_COVER from '@/assets/bg-back.png'

// import PageTips from "./components/PageTips";

defineProps({
  moduleData: {
    type: Object,
    default: () => {
      return {};
    },
  },
  bottomLogo: {
    type: String,
  },
});
</script>

<style lang="less">
.page24 {
  background: #333333;
  position: relative;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 1080px;
    overflow: hidden;

    & > img:first-child {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    & > img:nth-child(2) {
      z-index: 2;
      width: 30%;
      height: auto;
    }
  }
}
</style>
